import moment from "moment";
import React, { Fragment, useContext, useState } from "react";
import { useQuery } from "react-query";
import { Logout, ToastMessage } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import { useNavigate, useParams } from "react-router-dom";
import { REDIRECT_PATH } from "../../../../Routes";
import RiderContext from "../../../../context/RiderContext/RiderContext";
import { get_Rider_Wallet_History } from "../../../../Apis/riderApi/RiderApi";
import Breadcrumb from "../../../../reuseable/Breadcrumb/Breadcrumb";
import {
  RIDER_,
  RIDER_ONLINE_OFFLINE_ITEM,
  SLACE,
} from "../../../../reuseable/Breadcrumb/BreadcrumbConstant";
import { BackButton } from "../../../../reuseableComponents/buttons";

const RiderWalletHistoryDataTabelContainer = () => {
  const { filter, setFilter } = useContext(RiderContext);
  const history = useNavigate();

  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [record, setRecord] = useState(0);
  const [sortOrder, setSortOrder] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [dateValue, setDateValue] = useState(null);
  const { riderId } = useParams();

  /**
   * get rider wallet history List
   */

  let paramsObj = {
    pageNumber: page,
    recordsPerPage: pageSize,
    sortOrder,
    sortBy,
    search: {
      riderId,
    },
  };

  const handleChangeDate = (e) => {
    const { value } = e.target;
    setDateValue(value);
  };

  if (dateValue !== null) {
    paramsObj["search"] = {
      riderId,
      selectedDate: moment(dateValue).format(),
    };
  }

  let {
    data: riderWalletHistoryData,
    isLoading: riderWalletHistoryLoader,
    error: riderWalletHistoryError,
  } = useQuery(
    ["getRiderWalletHistory", paramsObj],
    async () => await get_Rider_Wallet_History(paramsObj),
    {
      onSuccess: (response) => {
        if (response.status === 200) {
          setRecord(response.pager.totalRecords);
        }
      },
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  if (riderWalletHistoryError) {
    const { status, message } =
      riderWalletHistoryError?.response?.data || riderWalletHistoryError;
    ToastMessage(status, message);
    Logout(history, status);
  }

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const handleOpenandClosePopup = () => {
    history(`${REDIRECT_PATH.RIDER}/add`);
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 180,
      field: "type",
      headerName: "Type",
      renderCell: (params) => (params.row.type === 1 ? "Credit" : "Debit"),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "debitAmount",
      headerName: "Debit Amount",
      renderCell: (params) =>
        params.row.debitAmount ? params.row.debitAmount : "--",
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "creditAmount",
      headerName: "Credit Amount",
      renderCell: (params) =>
        params.row?.creditAmount ? params.row?.creditAmount : "--",
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "currentAmount",
      headerName: "Current Amount",
      renderCell: (params) =>
        params.row?.currentAmount ? params.row?.currentAmount : "--",
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "refNo",
      headerName: "Ref No.",
      renderCell: (params) => (params.row?.refNo ? params.row?.refNo : "--"),
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "note",
      headerName: "Note",
      renderCell: (params) => (params.row?.note ? params.row?.note : "--"),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt).format("DD MMM, YYYY hh:mm"),
    },
  ];
  return (
    <Fragment>
      <Breadcrumb
        name={RIDER_}
        slace={SLACE}
        name1={RIDER_ONLINE_OFFLINE_ITEM}
      />
      <BackButton history={history} path={REDIRECT_PATH.RIDER} />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={riderWalletHistoryData}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={riderWalletHistoryLoader}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.riderWalletHistoryId}
        addButton={false}
        search={false}
        dateFilter={true}
        date={dateValue}
        handleChangeDate={handleChangeDate}
        isRange={false}
        dateFilterPlaceholder={"Date"}
      />
    </Fragment>
  );
};

export default RiderWalletHistoryDataTabelContainer;
